import React from "react";
import ErrorBoundary from "../../../../error-boundary";
import DateWrapper from "@default/js/participants/components/date-wrapper";
import TimetableAccessibilityInfos from "@default/teasers/appearance/components/timetable-accessibility-infos";
import { useSelector } from "react-redux";
import FestivalDay from "@default/general-components/date-time/festival-day";
import { Time } from "@carbon/icons-react";
import IconLocation from "@default/assets/ui/icon-location-16.svg?url";
import IconClock from "@default/assets/ui/icon-clock-16.svg?url";
import IconWarning from "@default/assets/ui/icon-warning-16.svg?url";
import IconDot from "@default/assets/ui/icon-dot-16.svg?url";

const TimetableMetaInfos = ({ content, type }) => {
  const happeningContent = content.fieldHappening,
    appearanceContent = content,
    releaseState = useSelector(
      (reduxStore) => reduxStore.appStore.releaseState
    ),
    isMobile = useSelector((reduxStore) => reduxStore.appStore.isMobile),
    isElphi = content?.fieldVenueLocation?.label === "Elbphilharmonie",
    showDay = isElphi || releaseState.showDay;

  return (
    <ErrorBoundary>
      <div className="timetable-meta-infos">
        <div className="time-location-wrapper d-flex">
          <div className="d-flex gap-xs align-items-start">
            <img className="icon icon-16" src={IconClock} alt="" />
            {showDay && content.fieldWeekday ? (
              <div className="appearance-time body-m">
                <DateWrapper
                  content={content}
                  showEndDate={true}
                  showTBA={releaseState.showDate}
                />
              </div>
            ) : (
              <span className="body-m make-headline-light tba">TBA</span>
            )}
          </div>
          {/* Always show Elphi Location, regardless of release state */}
          <div className="d-flex gap-xs align-items-start">
            <img className="icon icon-16" src={IconLocation} alt="" />
            {appearanceContent.fieldVenueLocation &&
            (releaseState.showDate ||
              appearanceContent?.fieldVenueLocation?.label ===
                "Elbphilharmonie") ? (
              <span className={"label body-m make-headline-light"}>
                {appearanceContent.fieldVenueLocation.label}
              </span>
            ) : (
              <span className={"label body-m make-headline-light"}>TBA</span>
            )}
          </div>
        </div>
        {showDay && releaseState.showDay && (
          <FestivalDay appearance={content} />
        )}
        {type && (
          <div className="d-flex gap-xs align-items-start">
            <img className="icon icon-16" src={IconDot} alt="" />
            <span>{type}</span>
          </div>
        )}

        {!isMobile && (
          <TimetableAccessibilityInfos content={content} color={"black"} />
        )}

        {happeningContent?.fieldInvitationOnly && (
          <div className="d-flex gap-xs align-items-start">
            <img className="icon icon-16" src={IconWarning} alt="" />
            <span>Invitation only</span>
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default TimetableMetaInfos;
